import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'components/v2/dropdowns/DropdownV2';
import ListItem from 'components/v2/list/ListItem';
import FSCSettingsForm from 'components/modules/user/rates/drayage/FSCSettingsForm';
import { useTranslation } from 'react-i18next';
import FSCSettingsSummary from './FSCSettingsSummary';
export default function FSCSettingListItem({ data, actionsEnabled, defaultOpen, onChange = () => { }, onDelete = () => { }, testDataId, }) {
    const { t } = useTranslation();
    function renderForm(saving, onSaveSuccess, onSaveFail, hideFormView) {
        return (React.createElement(FSCSettingsForm, { accountId: data.accountId, data: data, saving: saving, onSaveSuccess: () => {
                hideFormView();
                onSaveSuccess();
                onChange();
            }, onSaveFail: onSaveFail }));
    }
    function handleShowEditMode(showFormView) {
        return function () {
            showFormView();
        };
    }
    function handleDelete() {
        onDelete(data);
    }
    function renderActions(showFormView) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Dropdown.Button, { onClick: handleShowEditMode(showFormView), dataTestId: "edit-dropdown-option" }, t('EDIT')),
            React.createElement(Dropdown.Button, { onClick: handleDelete, dataTestId: "delete-dropdown-option" },
                t('DELETE'),
                ' ')));
    }
    return (React.createElement(ListItem, { actionsEnabled: actionsEnabled, actions: renderActions, form: renderForm, testDataId: testDataId, actionTestDataId: "drayage-save-fsc-config", cancelTestDataId: "drayage-cancel-fsc-config" }, () => React.createElement(FSCSettingsSummary, { data: data, accountId: data.accountId, defaultOpen: defaultOpen })));
}
FSCSettingListItem.propTypes = {
    actionsEnabled: PropTypes.bool,
    defaultOpen: PropTypes.bool,
    testDataId: PropTypes.string,
};
FSCSettingListItem.defaultProps = {
    actionsEnabled: false,
    defaultOpen: false,
};
